"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
require("./Tooltip.scss");
class Tooltip {
  constructor(container) {
    this.container = container.append('div').classed('below', true).classed('tooltip-wrapper', true);
    this.container.append('div').classed('tooltip-arrow', true).classed('tooltip-shadow', true);
    const content = this.container.append('div').classed('tooltip-content', true);
    this.container.append('div').classed('tooltip-arrow', true);
    content.append('div').classed('tooltip-title', true);
    content.append('div').classed('tooltip-total', true);
    content.append('div').classed('tooltip-subtitle', true);
    content.append('div').classed('tooltip-grid', true);
    this.rowFuncs = {
      value: Tooltip.rowValue,
      annotationTitle: Tooltip.rowAnnotationTitle,
      annotationText: Tooltip.rowAnnotationText,
      keyValues: Tooltip.rowKeyValues,
      keyValueLeft: Tooltip.rowKeyValueLeft,
      bar: Tooltip.rowBar,
      breakdown: Tooltip.rowBreakdown
    };
    this.shouldShow = false;
    this.fullTableWidth = 4;
  }
  static colour(d, colour) {
    return d.colour || colour || 'black';
  }
  // eslint-disable-next-line default-param-last
  draw(left, y, topContent, rows, colours) {
    let yOffset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 4;
    let forcePosition = arguments.length > 6 ? arguments[6] : undefined;
    this.drawHeader(topContent, colours);
    this.drawTable(rows, colours);
    this.container.style('transform', `translateX(${left}px)`);
    this.shouldShow = true;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const parentDim = this.container.node().parentNode.getBoundingClientRect();
        const tooltipDim = this.container.node().getBoundingClientRect();
        this.container.select('div.tooltip-content').style('transform', `translate(${Math.max(-tooltipDim.width / 2, -left) + Math.min(0, parentDim.right + tooltipDim.width / 2 - tooltipDim.right)}px, ${forcePosition === 'center' ? '-50%' : '0'})`);
        if (forcePosition === 'below' || forcePosition !== 'above' && parentDim.height - y + yOffset + 5 + tooltipDim.height > parentDim.height) {
          this.container.classed('below', true).classed('above', false).classed('centered', false).style('bottom', null).style('top', `${y + yOffset}px`);
        } else if (forcePosition === 'center') {
          this.container.classed('centered', true).classed('below', false).classed('above', false).style('bottom', null).style('top', `${y + yOffset}px`);
        } else {
          this.container.classed('above', true).classed('below', false).classed('centered', false).style('top', null).style('bottom', `${parentDim.height - y + yOffset + 5}px`);
        }
        if (this.shouldShow) {
          this.show();
        }
      });
    });
  }
  drawHeader(_ref, _ref2) {
    let {
      title,
      total,
      subtitle
    } = _ref;
    let {
      primaryColour
    } = _ref2;
    if (title) {
      this.container.select('div.tooltip-title').style('color', title.colour || primaryColour || 'black').text(title.value);
    } else {
      this.container.select('div.tooltip-title').text('');
    }
    if (total) {
      this.container.select('div.tooltip-total').style('color', total.colour || primaryColour || 'black').text(total.value);
    } else {
      this.container.select('div.tooltip-total').text('');
    }
    if (subtitle) {
      this.container.select('div.tooltip-subtitle').style('color', subtitle.colour).text(subtitle.value);
    } else {
      this.container.select('div.tooltip-subtitle').text('');
    }
  }
  drawTable(rows, colours) {
    const tooltip = this;
    const tableRows = this.container.select('.tooltip-grid').selectAll('div.tooltip-row').data(rows, d => `${d.type}-${d.key}`);
    tableRows.enter().append('div').classed('tooltip-row', true);
    tableRows.exit().remove();
    this.container.select('.tooltip-grid').selectAll('div.tooltip-row').each(function (d) {
      tooltip.rowFuncs[d.type](d3.select(this), d, colours);
    });
    this.container.classed('tooltip-large', !tableRows.selectAll('.tooltip-bar').empty() || !tableRows.selectAll('.tooltip-breakdown').empty());
  }
  static rowValue(div, d, _ref3) {
    let {
      primaryColour
    } = _ref3;
    let rowValue = div.select('.tooltip-value');
    if (rowValue.empty()) {
      rowValue = div.append('div').classed('tooltip-value', true);
    }
    if (d.html) {
      rowValue.html(d.value);
    } else {
      rowValue.style('color', Tooltip.colour(d, primaryColour)).text(d.value);
    }
    if (d.styles) {
      Object.keys(d.styles).forEach(k => {
        rowValue.style(k, d.styles[k]);
      });
    }
  }
  static rowAnnotationTitle(div, d) {
    let titleDiv = div.select('.tooltip-annotation-title');
    if (titleDiv.empty()) {
      titleDiv = div.append('div').classed('tooltip-annotation-title', true);
    }
    titleDiv.text(d.value);
  }
  static rowAnnotationText(div, d) {
    let textDiv = div.select('.tooltip-annotation-text');
    if (textDiv.empty()) {
      textDiv = div.append('div').classed('tooltip-annotation-text', true);
    }
    textDiv.text(d.value);
  }
  static rowKeyValues(div, d, _ref4) {
    let {
      primaryColour
    } = _ref4;
    div.classed('shrink-left', true);
    const keys = div.selectAll('div.tooltip-key').data(d.values, dd => dd.key).join(enter => {
      let selection = null;
      enter.each(v => {
        const keyDiv = div.append('div').classed('tooltip-key', true).datum(v);
        div.append('div').classed('tooltip-key-value', true).datum(v);
        if (!selection) {
          selection = keyDiv;
        } else {
          selection = selection.merge(keyDiv);
        }
      });
      return selection;
    }, update => update, exit => {
      exit.each(v => {
        div.selectAll('div.tooltip-key-value').filter(vv => v.key === vv.key).remove();
      }).remove();
    }).each(v => {
      const keyValue = div.selectAll('div.tooltip-key-value').style('color', Tooltip.colour(d, primaryColour)).filter(vv => v.key === vv.key).datum(v).text(vv => vv.value);
      if (v.styles) {
        Object.keys(v.styles).forEach(k => {
          keyValue.style(k, v.styles[k]);
        });
      }
    });
    keys.text(v => v.key).each(function (v) {
      if (v.styles) {
        Object.keys(v.styles).forEach(k => {
          d3.select(this).style(k, v.styles[k]);
        });
      }
    });
  }
  static rowKeyValueLeft(div, d, _ref5) {
    let {
      primaryColour
    } = _ref5;
    let rowValue = div.select('.tooltip-value-left');
    if (rowValue.empty()) {
      rowValue = div.append('div').classed('tooltip-value-left', true);
    }
    let rowKey = div.select('.tooltip-key-left');
    if (rowKey.empty()) {
      rowKey = div.append('div').classed('tooltip-key-left', true);
    }
    div.select('.tooltip-key-left').text(d.key);
    div.select('.tooltip-value-left').style('color', Tooltip.colour(d, primaryColour)).text(d.value);
  }
  static rowBar(div, d, _ref6) {
    let {
      primaryColour
    } = _ref6;
    let rowBar = div.select('.tooltip-bar');
    if (rowBar.empty()) {
      rowBar = div.append('div').classed('tooltip-bar', true);
      rowBar.append('div').classed('tooltip-bar-back', true);
      rowBar.append('div').classed('tooltip-bar-percent', true);
    }
    rowBar.select('.tooltip-bar-percent').style('transform', `translate(-${(1 - d.value) * 50}%, 0) scaleX(${d.value})`).style('background', Tooltip.colour(d, primaryColour));
  }
  static rowBreakdown(div, d, _ref7) {
    let {
      primaryColour,
      secondaryColour
    } = _ref7;
    let rowLeft = div.select('.tooltip-breakdown-left');
    if (rowLeft.empty()) {
      rowLeft = div.append('div').classed('tooltip-breakdown-left', true);
      rowLeft.append('div').classed('tooltip-breakdown-title', true);
      rowLeft.append('div').classed('tooltip-breakdown-total', true);
    }
    let rowRight = div.select('.tooltip-breakdown-right');
    if (rowRight.empty()) {
      rowRight = div.append('div').classed('tooltip-breakdown-right', true);
    }
    rowLeft.select('.tooltip-breakdown-title').text(d.key);
    rowLeft.select('.tooltip-breakdown-total').style('color', Tooltip.colour(d, primaryColour)).text(d.value);
    rowRight.selectAll('div').remove();
    rowRight.selectAll('div.breakdown-row-value').data(d.breakdown, dd => dd.key).join(enter => {
      enter.each(v => {
        rowRight.append('div').classed('breakdown-row-sign', true).datum(v);
        rowRight.append('div').classed('breakdown-row-value', true).datum(v);
        rowRight.append('div').classed('breakdown-row-key', true).datum(v);
      });
    }, update => update, exit => {
      exit.each(v => {
        rowRight.selectAll('div.breakdown-row-sign').filter(vv => v.key === vv.key).remove();
        rowRight.selectAll('div.breakdown-row-key').filter(vv => v.key === vv.key).remove();
      }).remove();
    });
    const values = rowRight.selectAll('div.breakdown-row-value');
    values.each(v => {
      rowRight.selectAll('div.breakdown-row-key').filter(vv => v.key === vv.key).datum(v).text(vv => `\xa0${vv.key}`);
      rowRight.selectAll('div.breakdown-row-sign').filter(vv => v.key === vv.key).datum(v).style('color', Tooltip.colour(d, secondaryColour)).text(vv => vv.sign || '');
    });
    values.style('color', Tooltip.colour(d, secondaryColour)).text(v => v.value);
  }
  show() {
    this.container.classed('show', true);
  }
  hide() {
    this.container.classed('show', false);
    this.shouldShow = false;
  }
}
exports.default = Tooltip;